import { Creatable as ReactSelect } from 'react-select';
import { deprecated } from '../../constants/texts';

import PropTypes from 'prop-types';

export default class Select extends React.PureComponent {
  static propTypes = {
    autoFocus: PropTypes.bool,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    multi: PropTypes.bool,
    name: PropTypes.string.isRequired,
    onBlur: PropTypes.func,
    onChange: PropTypes.func.isRequired,
    onNewOptionClick: PropTypes.func,
    onNewOptionCreate: PropTypes.func,
    options: PropTypes.array.isRequired,
    styles: PropTypes.object,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]),
  };

  static defaultProps = {
    autoFocus: false,
    className: '',
    disabled: false,
    multi: false,
  };

  componentDidMount() {
    console.warn('ReactSelect -- ', deprecated);
  }

  render() {
    const {
      autoFocus,
      className,
      disabled,
      name,
      options,
      value,
      title,
      multi,
      onBlur,
      onChange,
      onNewOptionClick,
      onNewOptionCreate,
      styles,
    } = this.props;

    return (
      <ReactSelect
        autoFocus={autoFocus}
        className={className}
        classNamePrefix="Edocat-Select"
        id={name}
        isDisabled={disabled}
        isMulti={multi}
        name={name}
        noOptionsMessage={() => window.Alfresco.messages.global['edocat.text.no-results']}
        onBlur={onBlur}
        onChange={onChange}
        onCreateOption={onNewOptionCreate || onNewOptionClick}
        options={options}
        placeholder={`${window.Alfresco.messages.global['button.select']}...`}
        promptTextCreator={label => `Přidat hodnotu "${label}"`}
        searchPromptText={window.Alfresco.messages.global['edocat.forms.select.search-prompt-text']}
        title={title}
        value={value}
        styles={{
          ...styles,
          container: base => ({
            ...base,
            zIndex: 5,
          }),
          control: base => ({
            ...base,
            borderColor: '#ccc',
            boxShadow: 'none',
            background: '#fff',
            '&:hover': {
              borderColor: '#ccc',
              boxShadow: 'none',
            },
          }),
        }}
      />
    );
  }
}
